import { Flex, Box, Icon } from '@weareberyl/design-system'
import { ReactNode } from 'react'
import { ZoneType } from '~/__generated__/globalTypes'
import TabIcon from '../shared/TabIcon'

type ZoneTypeStatusProps = {
  zoneType: ZoneType
  isPromotional?: boolean
  isSuspended?: boolean
  isPriority?: boolean
}

const Overlay = ({
  isPromotional,
  isPriority,
}: {
  isPromotional?: boolean
  isPriority?: boolean
}) => {
  if (!isPromotional && !isPriority) return null

  return (
    <Box
      alignItems="center"
      mt="-14px"
      ml="-9px"
      p="2px"
      height={16}
      minWidth={16}
      flexDirection="row"
    >
      {isPromotional && <TabIcon icon="star" size="small" overlap />}
      {isPriority && <TabIcon icon="sparkle" size="small" overlap />}
    </Box>
  )
}

const ZoneTypeStatus = ({
  zoneType,
  isPromotional,
  isSuspended,
  isPriority,
}: ZoneTypeStatusProps) => {
  const isWorkshop = zoneType === ZoneType.workshop
  const iconColor = isSuspended ? 'white' : 'grape'
  let bg = 'berylGreen'
  let icon = 'parking'
  if (isSuspended) {
    icon = 'noParking'
    bg = '#C9A4A7'
  }
  if (isWorkshop) {
    icon = 'spanner'
    bg = 'tumeric'
  }

  return (
    <Flex flexWrap="nowrap" alignItems="center" justifyContent="start">
      <Box
        borderRadius="100%"
        alignItems="center"
        bg={bg}
        mt="3px"
        p="2px"
        height={24}
        width={24}
        style={{ borderColor: '#C9A4A7' }}
      >
        <Icon color={iconColor} mt="2px" type={icon} width={16} height={16} />
      </Box>
      <Overlay isPromotional={isPromotional} isPriority={isPriority} />
    </Flex>
  )
}

export default ZoneTypeStatus
